<template>
  <div :class="['content', classClose]" @click="toggle" >
    <Stage1 v-if="!showFrame2 && (template.frame == 1 || !template.name)" @end="nextFrame" />
    <Stage2 v-if="showFrame2 || template.frame == 2" @end="nextFrame2" />
  </div>
</template>

<script>
import Stage1 from "./stage1.vue";
import Stage2 from "./stage2.vue";
export default {
  components: { Stage1, Stage2 },
  props: { template: { type: Object, default: () => ({last: true}) } },
  data: () => ({
    classClose: '',
    showFrame2: false
  }),

  methods: {
    toggle(){
      if(this.$store.state.playlist.showPreviewOld){
        this.showFrame2 = !this.showFrame2

      }
    },
    nextFrame(isBack= false){
      if(isBack){
        return this.$emit("end", this.template.index - 2)
      }
      if(!this.template.last){
        this.$emit('end', this.template.index)
      }
      else{
        if(this.template.last && this.showFrame2){
        return this.$emit('end', this.template.index)
      }
        this.showFrame2 = true
      }
    },
    nextFrame2(){
      this.$emit('end', this.template.index)
    },
  },
  watch:{
    "$store.state.templates.nextTemplate"(){
      this.nextFrame()
    },
    "$store.state.templates.backTemplate"(){
      if(this.showFrame2){
        return this.showFrame2 = false
      }
      this.$emit("back", this.template.index)
    },
  }
};
</script>

<style  scoped>
@font-face {
  font-family: "tn";
  src: url("/fonts/HurmeGeometricSans1.otf");
}

@font-face {
  font-family: "tn-bold";
  src: url("/fonts/HurmeGeometricSans1_Bold.otf");
}

@font-face {
  font-family: "tn-semibold";
  src: url("/fonts/HurmeGeometricSans1_SemiBold.otf");
}
.content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .5s ease;
  opacity: 1;
}

.content-close{
  opacity: 0;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

</style>